import { render, staticRenderFns } from "./HelpCenterProductUpdateSkeleton.vue?vue&type=template&id=00c0d3c2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports